/**
 * Scroll Animations for Pet Society Japan
 * Fade-in elements on scroll with intersection observer
 */

(function() {
  'use strict';

  // Check for IntersectionObserver support
  if (!('IntersectionObserver' in window)) {
    // Fallback: show all elements immediately
    document.querySelectorAll('.fadein, .fadein-left, .fadein-right, .scalein, .fadein-stagger, .brands__image-top, .brands__list, .brands__content, .brands__image-bottom, .rich-text__heading, .rich-text__text, .rich-text__buttons, .dual-category__item, .dual-category__label, .dual-category__title, .dual-category__description, .dual-category__button').forEach(function(el) {
      el.classList.add('scrollin');
    });
    return;
  }

  // Configuration
  const config = {
    root: null,
    rootMargin: '0px 0px -100px 0px',
    threshold: 0.1
  };

  // Callback function
  function handleIntersection(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('scrollin');
        observer.unobserve(entry.target);
      }
    });
  }

  // Create observer
  const observer = new IntersectionObserver(handleIntersection, config);

  // Japanese text line break control
  // Wraps text segments between <wbr> tags in nowrap spans
  function initTextSegments() {
    const selectors = 'h1, h2, h3, .hero-philosophy__tagline, .about-hero__tagline, .dual-category__title, .commitment__title, .story-block__title, .brands__content-title, .brands__slide-title';

    document.querySelectorAll(selectors).forEach(function(el) {
      if (el.innerHTML.includes('<wbr>')) {
        el.innerHTML = el.innerHTML
          .split('<wbr>')
          .map(function(segment) {
            return '<span class="text-segment">' + segment.trim() + '</span>';
          })
          .join('<wbr>');
      }
    });
  }

  // Initialize on DOM ready
  function init() {
    // Process Japanese text segments first
    initTextSegments();

    const animatedElements = document.querySelectorAll('.fadein, .fadein-left, .fadein-right, .scalein, .fadein-stagger, .brands__image-top, .brands__list, .brands__content, .brands__image-bottom, .rich-text__heading, .rich-text__text, .rich-text__buttons, .dual-category__item, .dual-category__label, .dual-category__title, .dual-category__description, .dual-category__button');

    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    init();
  });

})();
